<template>
  <div class="wrap wrap-intel">
    <div class="banner">
      <img src="@/assets/img/设备及原料/仪器设备/氨解仪/banner.jpg" class="img-fluid">
      <div class="banner-info">
        <div class="left">
          <h2>氨解仪</h2>
          <p style="line-height: 2;font-size: 16px">擎科生物研制的氨解仪可提供寡核苷酸合成后脱保护基的全方位解决方案。灵活的氨气/水操作选择可90分钟完成一次脱保护工作，有效提升40%的工作效率。整机采用全不锈钢结构配合多种安全防护设计，快捷、稳定、高效制备生物样品的同时更为实验人员提供更高层级的安全防护。内部管路材质为PTFE，具有超强的生物适应性，有效延长仪器的使用寿命。</p>
        </div>
        <div class="img_a" style="width:40%"><img src="@/assets/img/设备及原料/仪器设备/氨解仪/氨解仪整体展示.png" width="100%"  class="product"></div>
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
   
    <section class="container container1">
      <div class="c-title">产品特点</div>
      <el-row :gutter="90" type="flex" align="middle">
        <el-col :span="8">
          <div class="tc"><img src="@/assets/img/设备及原料/仪器设备/氨解仪/氨解仪.png" width="260"></div>
        </el-col>
        <el-col :span="16" class="right-col">
          <ul class="lists">
            <li>可同时对两块96孔合成板192条引物进行氨解反应</li>
            <li>90℃/2h快速氨解，切割效率≥99%</li>
            <li>三重安全压力保护，进口电磁阀搭配机械泄压阀同时工作，550KPa安全压力保护，超压电子报警并自动停止进气</li>
            <li>600 KPa高压自动快速排气泄压</li>
            <li>氨解反应结束后提示</li>
          </ul>
        </el-col>
      </el-row>
    </section>
     <!-- <div class="container">
      <p class="desc" style="padding-top: 20px;padding-bottom: 20px;">氨解仪用于合成后的氨解工作。可同时对多块96孔合成板进行氨解反应。在氨解锅中加入液态氨水或氨气，将96孔合成板放置于氨解锅中，通过温控装置调节氨解锅的温度，氨解锅中充满氨气，并形成一定的压力，在高温下经过较短时间（约2小时）去除合成后引物上的保护基团，得到不含保护基团的寡核苷酸单链。</p>
    </div> -->
    <!-- <section class="save" >
      <div class="c-title">产品特点</div>
      <div class="container container1">
      <el-row :gutter="90" type="flex" align="middle">
        <el-col :span="12">
          <div class="tc"><img src="@/assets/img/设备及原料/仪器设备/氨解仪/氨解仪.png" width="100%"></div>
        </el-col>
        <el-col :span="12" style="padding-left: 0;padding-right: 0;">
          <ul class="lists">
            <li>支持2个96孔板192条引物氨解;</li>
            <li>550KPa安全压力保护，超压电子报警并自动停止进气，同时机械安全阀自动排气降低压力，三重安全保护;</li>
            <li>600KPa高压自动快速排气泄压;</li>
            <li>90℃/2H快速氨解，切割效率≥99%;</li>
            <li>氨解反应结束后音乐提示;</li>
          </ul>
        </el-col>
      </el-row>
      </div>
    </section> -->
    <section class="container container1">
      <div class="c-title">性能参数</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">容量</td>
              <td>96 x 2条引物</td>
            </tr>
            <tr>
              <td>功率</td>
              <td>1 KW</td>
            </tr>
            <tr>
              <td>工作压力</td>
              <td>480 Kpa</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">自动排气保护压力</td>
              <td>550 Kpa</td>
            </tr>
            <tr>
              <td>机械排气保护压力</td>
              <td>600 Kpa</td>
            </tr>
            <tr>
              <td>外形尺寸</td>
              <td>600 x 400 x 400 mm</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </section>
    <section class="save">
      <div class="c-title">工作环境</div>
      <div class="container container1">
        <ul>
          <li>
            <img src="@/assets/images/save_icon_1.png">
            <h4>温度要求:</h4>
            <p>20℃~25℃</p>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/氨解仪/通风.png">
            <h4>通风要求:</h4>
            <p>必须放置于通风橱内</p>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/氨解仪/空气清洁.png">
            <h4>空气洁净要求：</h4>
            <p>无</p>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/氨解仪/电源.png">
            <h4>电源要求：</h4>
            <p>AC220V</p>
          </li>
        </ul>
      </div>
    </section>
    <!-- <section class="container container1" >
      <div class="c-title">配置清单</div>
            <ul class="lists1 lists">
              <li>氨解仪    1台;</li>
              <li>96孔板放置架   1套;</li>
            </ul>
    </section> -->
    <section class="container">
       <div class="dispose">
        <div class="title">标准配置</div>
        <el-row class="text-row">
          <el-col :span="24" class="list-item"><div><span class="circle"></span>氨解仪 1台</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="24" class="list-item"><div><span class="circle"></span>96孔板放置架 1套</div></el-col>
        </el-row>
      </div>
   </section>
    <section class="container container1" >
      <div class="c-title">仪器展示</div>
      <ul class="ul">
        <li><img src="@/assets/img/设备及原料/仪器设备/氨解仪/yiqi1.png" alt="" class="img-fluid" height="100%"></li>
        <li><img src="@/assets/img/设备及原料/仪器设备/氨解仪/yiqi2.png" alt="" class="img-fluid" height="100%"></li>
      </ul>
    </section>
  </div>
</template>
<style scoped>
@import url("../../assets/akta.css");
</style>
<style scoped lang="scss">
.wrap-intel .save p{
  margin-top: 10px!important;
}
.container1 .lists1{
  overflow: auto;
  text-align: left;
  margin-left: 20%;
}

.container1 .ul{
  overflow: auto;
  margin-left: 20%;
}
.container1 .ul li{
  float: left;
}
.lists{
    display: unset !important;
    li{
      text-align: left;
    }
  }
  /deep/.right-col{
    padding: 0 !important;
  }
  .center-ele{
  margin-left: 100px;
  text-align: center;
  font-weight: bold;
}
.desc-ch{
  margin-top:-35px;
}
.desc-eh{
  margin-top:-16px;
}
.text-desc-list{
  padding-left: 26px;
}
.list-item{
  position: relative;
  padding-left: 20px !important;
}
.circle{
  display: inline-block;
  background: #014492;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 20px;
  position: absolute;
  left: 0px;
  top:4px;
}
.text-row{
  padding:10px 0;
}
</style>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/am096.vue